import script from "./GalaxyImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./GalaxyImage.vue?vue&type=script&lang=ts&setup=true"

import "./GalaxyImage.vue?vue&type=style&index=0&id=07d5d6b2&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d5d6b2"]])

export default __exports__